import * as React from 'react'
import PropTypes from 'prop-types'

import { Container, Intro } from './style'

import formatSimpleMarkdown from '../../../../helpers/format-simple-markdown'
import { H1 } from '../../../../ui/landing-page-headings'
import LandingPageBlockWrapper from '../../../../ui/landing-page-block-wrapper'

const ControlpanelEventplannerBlock = React.memo(({ heading, theme, anchorId }) => {
  const headingValue = formatSimpleMarkdown(heading)

  return (
    <LandingPageBlockWrapper theme={theme} anchorId={anchorId}>
      <H1 dangerouslySetInnerHTML={{ __html: `${headingValue}` }} />
    </LandingPageBlockWrapper>
  )
})

ControlpanelEventplannerBlock.propTypes = {
  heading: PropTypes.string,
  intro: PropTypes.string,
  anchorId: PropTypes.string,
  theme: PropTypes.string.isRequired,
}

ControlpanelEventplannerBlock.defaultProps = {
  anchorId: '',
  heading: '',
  intro: '',
}

export default ControlpanelEventplannerBlock
